"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusLock = void 0;

var _react = require("react");

var _useCursor2 = require("use-cursor");

var _useMutationObserver = require("./useMutationObserver");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FOCUSABLE_SELECTOR = ["a[href]:not([tabindex='-1'])", "area[href]:not([tabindex='-1'])", "input:not([disabled]):not([tabindex='-1'])", "select:not([disabled]):not([tabindex='-1'])", "textarea:not([disabled]):not([tabindex='-1'])", "button:not([disabled]):not([tabindex='-1'])", '[tabindex="0"]'].join(", ");
/**
 * Locks focus within the given element
 */

var useFocusLock = function useFocusLock(ref) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      focusableEls = _useState2[0],
      setFocusableEls = _useState2[1];

  var updateFocusableEls = (0, _react.useCallback)(function () {
    if (ref.current === null) return;
    setFocusableEls(Array.from(ref.current.querySelectorAll(FOCUSABLE_SELECTOR))); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Set initial focusable elements on mount

  (0, _react.useEffect)(updateFocusableEls, [updateFocusableEls]);
  var skipUpdateFocusRef = (0, _react.useRef)(false); // Detects when DOM changes and updates focusable elements

  (0, _useMutationObserver.useMutationObserver)({
    ref: ref,
    onMutate: function onMutate(mutations) {
      // Check to see if any of the mutations has either added or removed nodes
      var hasMeaningfullyMutated = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      });

      if (hasMeaningfullyMutated) {
        skipUpdateFocusRef.current = true;
        updateFocusableEls();
      }
    }
  });

  var _useCursor = (0, _useCursor2.useCursor)({
    max: focusableEls.length
  }),
      focusableIndex = _useCursor.index,
      handlePrev = _useCursor.handlePrev,
      handleNext = _useCursor.handleNext,
      setCursor = _useCursor.setCursor; // Moves focus when index changes


  (0, _react.useEffect)(function () {
    if (!focusableEls.length) return; // In order to avoid a loop when a focus might be the cause of a mutation,
    // we skip focusing the el.

    if (skipUpdateFocusRef.current) {
      skipUpdateFocusRef.current = false;
      return;
    }

    focusableEls[focusableIndex].focus();
  }, [focusableEls, focusableIndex]); // Handle keyboard navigation

  (0, _react.useEffect)(function () {
    var handleKeydown = function handleKeydown(event) {
      switch (event.key) {
        case "Tab":
          // Lock focus within element
          event.preventDefault();
          event.stopPropagation(); // Move focus up or down

          event.shiftKey ? handlePrev() : handleNext();
          break;

        default:
          break;
      }
    };

    var focusedElPriorToOpen = document.activeElement;
    document.addEventListener("keydown", handleKeydown);
    return function () {
      // Return the focus
      focusedElPriorToOpen.focus();
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [handleNext, handlePrev]);
  (0, _react.useEffect)(function () {
    // Update the index when any focusable is clicked
    var handleClick = function handleClick(event) {
      if (event.target !== document.activeElement) return;
      var index = focusableEls.findIndex(function (node) {
        return node === event.target;
      });
      if (index === -1) return;
      setCursor(index);
    }; // If focus escapes the trap, pull it back in


    var handleFocusIn = function handleFocusIn(event) {
      var index = focusableEls.findIndex(function (node) {
        return node === event.target;
      });
      var focusableEl = focusableEls[focusableIndex];

      if (index === -1 && !!focusableEl) {
        event.stopImmediatePropagation();
        focusableEl.focus();
        return;
      }
    };

    document.addEventListener("click", handleClick);
    document.addEventListener("focusin", handleFocusIn);
    return function () {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, [focusableEls, focusableIndex, setCursor]);
};

exports.useFocusLock = useFocusLock;